import styled from 'styled-components/macro';
import * as breakpoints from '../../common/mediaQueries';
import * as colors from '../../common/colorConstants';

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    flex-direction: column;
  }
`;

export const Main = styled.main`
  flex: 0 0 413px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: ${colors.white};
  position: relative;
  border-left: 1px solid ${colors.electricBlue};

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    flex: 1 0 370px;
  }

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    border-top: 1px solid ${colors.electricBlue};
    border-left: none;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    flex: 1 0 auto;
    justify-content: flex-start;
    align-items: center;
    height: calc(100% - 72px);
    background: ${colors.lightGray4};
  }
`;

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  padding: 66px;
  height: 100%;
  width: 100%;
  background: ${colors.aliceBlue};

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 370px;
    flex-direction: row;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    flex: 0 0 72px;
    flex-direction: row;
    padding: 0 30px;
    border: none;
    background: ${colors.darkGray2};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SimplrLogoWrapper = styled.div`
  height: 42px;
  width: 118px;
  display: block;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    display: none;
  }
`;

export const SimplrLogoMobileWrapper = styled.div`
  height: 30px;
  width: 85px;
  display: none;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    display: block;
  }
`;

export const Divider = styled.div`
  margin: ${({ space }) => `${space} 0`};
  border: 2px solid ${colors.electricBlue};
  border-radius: 2px;
  width: 30px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    margin: 25px 0;
  }
`;

export const Heading = styled.h2`
  margin: 0;
  margin-bottom: 50px;
  color: ${colors.electricBlue};
  font-family: Roboto, sans-serif;
  font-size: 4rem;
  font-weight: 400;
  line-height: 110%;
  letter-spacing: 0.03em;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    font-size: 3rem;
  }
`;

export const SimplrImage = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  background: url('/images/welcome-image/welcome_image_bg.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  height: 500px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 306px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    display: none;
  }
`;

export const HeaderText = styled.div`
  display: contents;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    display: none;
  }
`;

export const MobileHeaderText = styled.span`
  color: ${colors.lightGray1};
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  display: none;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    display: block;
  }
`;
